export const FeatureFlags = {
  ENABLE_ENHANCED_JOB_LIST_LAYOUT: 'enable-enhanced-job-list-layout',
  /** The answer filter in the candidate view. Targeted per company (clientId) or user in PostHog. */
  ANSWER_FILTER: 'answer-filter',
} as const;

export type FeatureFlags = (typeof FeatureFlags)[keyof typeof FeatureFlags];
